var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPorterAlert3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qvfuqt0o1a)",
    fill: "#6C7C8C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.118 18.556a2.312 2.312 0 1 0-.057-4.623 2.312 2.312 0 0 0 .057 4.623zM17.668 18.557a2.312 2.312 0 1 0-.056-4.624 2.312 2.312 0 0 0 .056 4.624z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.978 7.302a.739.739 0 0 0 .514.214l1.254 4.515a2.417 2.417 0 0 1-.557 2.309s-.746.804-1.863.805A1.335 1.335 0 0 1 11 13.81c0-.488.054-.974.162-1.45.14-.546.23-.724.397-1.067.546-.074.757-.877.353-1.53-.423-.688-1.35-.767-2.468-.376-1.119.391-2.163.18-3.607-.066-1.452-.248-1.679 1.979-.63 1.979h.633a4.648 4.648 0 0 0-1.756 1.87.753.753 0 0 0 .322 1.016.451.451 0 0 0 .518-.08c.348-.355.78-.617 1.254-.765.296-.089.603-.136.911-.14a3.046 3.046 0 0 1 3.038 3.233.154.154 0 0 0 .042.117.157.157 0 0 0 .114.049h3.531a.836.836 0 0 0 .807-.738 3.045 3.045 0 0 1 2.108-2.521 3.028 3.028 0 0 1 2.838.55c.222.182.536-.073.4-.325l-.004-.007a4.503 4.503 0 0 0-2.324-2c-.04-2.09-2.466-4.042-2.466-4.042.651.038.674-.61.674-.61.04-.787-.493-1.418-1.227-1.46a.894.894 0 0 0-.525.137l-.425.267c-.143.092-.293.17-.449.235a.743.743 0 0 0-.44.503s-.196.058-.268.125a.347.347 0 0 0 .178.607s.1.017.286-.02z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qvfuqt0o1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorterAlert3);
export default __webpack_public_path__ + "static/media/porter_alert3.1fd70197154ab703491aeceb167f4bf7.svg";
export { ForwardRef as ReactComponent };